export function toggleYesNo() {
  var value = $(this).siblings( "span" ).html() == 'Oui' ? 'Non' : 'Oui';
  $(this).siblings( "span" ).html(value);
}